<script setup name="Template3">
import { ref, onMounted, onUnmounted, computed, inject, watch } from "vue";
import ContainerCom from "./ContainerCom.vue";
import TextCom from "./TextCom.vue";
import ButtonCom from "./ButtonCom.vue";
// import productAPI from '../api/modules/product'
import { ElMessageBox } from "element-plus";

// 为模板组件定义属性
const props = defineProps({
  templateId: {
    type: String,
    default: "",
  },
});
const currentLanguage = inject("currentLanguage", "zh");
// 处理删除事件
const handleDelete = (contentId) => {
  // emit删除事件
  emit("handleDelete", props.templateId);
};
const contentMap = inject("contentMap", {});
const isLoggedIn = inject("isLoggedIn", false);
// 定义emits
const emit = defineEmits(["edit", "handleDelete"]);
// 滑动和动画相关状态
const isVisible = ref(false);
const isSliding = ref(true);
const textPosition = ref(0);
const scaleValue = ref(1.0); // 缩放比例，初始值为1
const lastScrollY = ref(0);
const templateRef = ref(null);
const topRef = ref(null);
const bottomRef = ref(null);
const scrollbarRef = ref(null);
const viewRef = ref(null);
// 是否是移动端
const isMobile = ref(window.innerWidth <= 768);

const textRef = ref(null);
const firstText = ref("人工肌肉");
const nextTextArr = ref(["人工肌肉1", "人工肌肉2", "人工肌肉3"]);
let observer = null;
let observerArr = null;
let scrollLock = false;
let actualTop = 0;
let t = null;
const reachedBottom = ref(false);
const reachedTop = ref(false);

// 计算TextCom的变换样式
const textTransform = computed(() => {
  return {
    transform: `translateY(${textPosition.value}px) scale(${scaleValue.value})`,
    transition: "transform 0.1s ease",
    opacity: 1 / scaleValue.value,
  };
});

const init = () => {
  const text =
    contentMap.value[props.templateId + "-text-1"][currentLanguage.value] || "";
  //   以；或;分割
  firstText.value = text.split(/[；;]/)[0];
  nextTextArr.value = text.split(/[；;]/).slice(1);
};

// 处理交叉观察器回调 - 检测模板是否可见
// const handleIntersect = (entries) => {
//   if (isMobile.value) {
//     return;
//   }
//   entries.forEach((entry) => {
//     if (entry.isIntersecting) {
//       startScrollListening();
//     }
//     // else {
//     //   setTimeout(() => {
//     //     isVisible.value = false;
//     //     isSliding.value = true;
//     //     // 当模板不可见时，停止监听滑动事件并恢复正常滑动
//     //     stopScrollListening();
//     //     // enableScroll()
//     //   }, 50);
//     // }
//   });
// };
const handleIntersect = () => {
  if (isMobile.value) {
    return;
  }
  if (!templateRef.value) {
     window.requestAnimationFrame(handleIntersect);
  }
  // 判断当前元素在视口中的位置,大于90%则开始监听滑动事件
  const rect = templateRef.value.getBoundingClientRect();
  // 计算元素在视口内的比例
  const elementHeight = rect.height;
  const visibleHeight =
    Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
  const visibleRatio = Math.max(0, visibleHeight / elementHeight);

  // 当90%以上内容在视口内时，开始监听滑动事件
  const isInViewport = visibleRatio >= 0.9;

  if (isInViewport) {
    startScrollListening();
  } else {
    window.requestAnimationFrame(handleIntersect);
  }
};

// 监听滑动事件 - 使用wheel事件（鼠标滚轮）和touch事件（触摸滑动）
const handleScroll = (e) => {
  let deltaY = 0;
  if (!templateRef.value) {
    return;
  }
  const rect = templateRef.value.getBoundingClientRect();
  // // 当templateRef不可见时，调用stopScrollListening
  // const isInViewport = rect.top < window.innerHeight && rect.bottom > 0;
  
  // if (!isInViewport) {
  //   stopScrollListening();
  // }



  // 判断鼠标是否在templateRef内
  const isMouseInViewport = rect.top <= e.clientY && e.clientY <= rect.bottom;
  // 处理鼠标滚轮事件
  if (e.deltaY) {
    deltaY = e.deltaY;
  }
  if (!isMouseInViewport) {
    return;
  }
  // 1.到达顶部，只阻止向下划的事件
  if(reachedTop.value) {
    if(deltaY > 0 && isMouseInViewport) {
      // 如果鼠标在外面，不阻止向下划
      e.preventDefault();
      reachedTop.value = false;
    } 
  }
  // 2.到达底部，只阻止向上划的事件
  if(reachedBottom.value) {
    if(deltaY < 0 && isMouseInViewport) {
      // 如果鼠标在外面，不阻止向上划
      e.preventDefault();
      reachedBottom.value = false;
    } 
  }
  // 没到达顶部也没到达底部，阻止下滑
  if(!reachedTop.value && !reachedBottom.value) {
    e.preventDefault();
  }
  // 处理触摸事件
  else if (e.touches && e.touches.length > 0) {
    // 这里可以添加触摸事件处理逻辑
    // deltaY = calculate from touch movement
  }

  // 当处于isSliding模式时，处理缩放动画
  if (isSliding.value) {
    const min = 1;
    const max = 10;
    const step = 0.002;

    if (deltaY > 0) {
      // 下滑 - 放大firstText
      scaleValue.value = Math.min(scaleValue.value + deltaY * step, max); // 最大放大到10倍
      if (scaleValue.value >= max) {
        // 到达最大缩放比例，切换到滚动模式
        isSliding.value = false;
        // stopScrollListening()
        observerArr = new IntersectionObserver(handleIntersectArr, {
          root: viewRef.value,
        });
        document.querySelectorAll(".next-text-content").forEach((item) => {
          observerArr.observe(item);
        });
      }
    } else if (deltaY < 0) {
      // 上滑 - 缩小firstText
      scaleValue.value = Math.max(scaleValue.value + deltaY * step, min); // 最小缩小到1倍
      if (scaleValue.value <= min) {
        reachedTop.value = true;
        reachedBottom.value = false;
        // 到达最小缩放比例，停止监听
        // stopScrollListening();
      }
    }
  }
  // 当处于非isSliding模式时，使用setScrollTop手动滑动el-scrollbar
  else if (scrollbarRef.value) {
    const scrollbar = scrollbarRef.value;
    let currentScrollTop = scrollbar.wrapRef.scrollTop;
    const scrollSpeed = 200; // 滚动速度
    const targetScrollTop = currentScrollTop + deltaY * (scrollSpeed / 100);
    if (targetScrollTop <= 0) {
      isSliding.value = true;
      return;
    }
    // 使用requestAnimationFrame实现平滑滚动
    let startTime = null;
    const duration = 300; // 动画持续时间（毫秒）

    const animateScroll = (timestamp) => {
      if (!startTime) startTime = timestamp;
      const elapsed = timestamp - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // 使用缓动函数使滚动更平滑
      const easeProgress = 1 - Math.pow(1 - progress, 3);
      const newScrollTop =
        currentScrollTop + (targetScrollTop - currentScrollTop) * easeProgress;

      scrollbar.setScrollTop(newScrollTop);

      if (progress < 1) {
        requestAnimationFrame(animateScroll);
      }
    };

    requestAnimationFrame(animateScroll);
  }
};

// 停止页面滚动
const lockScroll = () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

  // 固定页面位置
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollTop}px`;
  document.body.style.left = `-${scrollLeft}px`;
};

// 恢复页面滚动
const enableScroll = () => {
  // console.log('enableScroll')
  const bodyStyle = document.body.style;
  const top = bodyStyle.top;

  if (bodyStyle.position === "fixed") {
    // 恢复滚动位置
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    window.scrollTo(0, parseInt(top || "0") * -1);
  }

  scrollLock = false;
};

// 滑动结束处理
const handleTouchEnd = () => {
  // 恢复TextCom位置和缩放
  textPosition.value = 0;
  scaleValue.value = 1.0; // 恢复初始缩放值
  // 恢复页面滚动
  enableScroll();
};

const handleEndReached = (direction) => {
  // 滚动到最底部
  if (direction === "bottom") {
    reachedBottom.value = true;
    reachedTop.value = false;
  }
};
// const scrollListening = () => {
//   window.addEventListener("scroll", handleDocumentScroll);
// }
// const scrollListeningStop = () => {
//   window.removeEventListener("scroll", handleDocumentScroll);
// }
// let first = true
// const handleDocumentScroll = () => {
//   const scrollTop = window.scrollY || document.documentElement.scrollTop;
//   console.log(scrollTop)
//   // 当滚动到topRef位置时，开始监听滑动事件
//   if (scrollTop >= actualTop && first&& scrollTop !== 0) {
//     console.log('scrollTop >= actualTop')
//     startScrollListening();
//     first = false
//   }
// }
// 开始监听滑动事件
const startScrollListening = () => {
  // 使用wheel事件（鼠标滚轮），并设置passive: false允许preventDefault()
  window.addEventListener("wheel", handleScroll, { passive: false });
  // 添加触摸事件监听
  window.addEventListener("touchstart", handleScroll, { passive: false });
  window.addEventListener("touchmove", handleScroll, { passive: false });
  window.addEventListener("touchend", handleTouchEnd);
};

// 停止监听滑动事件
const stopScrollListening = () => {
  // console.log('stopScrollListening')
  window.removeEventListener("wheel", handleScroll, { passive: false });
  window.removeEventListener("touchstart", handleScroll, { passive: false });
  window.removeEventListener("touchmove", handleScroll, { passive: false });
  window.removeEventListener("touchend", handleTouchEnd);
  // 当完全从视口消失时，重新触发交叉观察器
  // t = setInterval(() => {
  //   // 判断是否完全不在视口内
  //   if (!templateRef.value) {
  //     clearInterval(t);
  //     return;
  //   }
  //   const rect = templateRef.value.getBoundingClientRect();
  //   // 元素完全在视口外：顶部在视口下方 或 底部在视口上方
  //   if (rect.top > window.innerHeight || rect.bottom < 0) {
  //     window.requestAnimationFrame(handleIntersect);
  //     clearInterval(t);
  //   }
  // }, 100);
};
const handleIntersectArr = (entries) => {
  entries.forEach((entry) => {
    // 根据交叉比例更新透明度
    entry.target.style.opacity = entry.intersectionRatio;
  });
};
const nextTextArrRef = ref([]);
const handleScrollEvent = (e) => {
  const scrollTop = e.scrollTop;
};

// 监听 isSliding 变化，当切换到非滑动模式时，初始化交叉观察器
watch(
  () => isSliding.value,
  (newValue) => {
    if (!newValue) {
      // 延迟初始化，确保 el-scrollbar 已渲染
      setTimeout(() => {
        // 创建交叉观察器，观察 next-text-content 元素
        observerArr = new IntersectionObserver(handleIntersectArr, {
          root: viewRef.value?.wrapRef || null, // 使用 el-scrollbar 的滚动容器
          rootMargin: "0px",
          threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0], // 多个阈值，确保持续触发
        });

        // 观察所有 next-text-content 元素
        document.querySelectorAll(".next-text-content").forEach((item) => {
          observerArr.observe(item);
        });
      }, 100);
    } else {
      // 清理之前的观察器
      if (observerArr) {
        observerArr.disconnect();
        observerArr = null;
      }
    }
  }
);

// 生命周期钩子
onMounted(() => {
  // 初始化交叉观察器，检测模板是否可见
  // observer = new IntersectionObserver(handleIntersect);

  // if (bottomRef.value) {
  //   observer.observe(bottomRef.value);
  // }
  // window.requestAnimationFrame(handleIntersect);
  init();
  startScrollListening();
  // 得到topRef位置
  // actualTop = topRef.value.offsetTop;
  // let current = topRef.value.offsetParent;
  // while (current !== null) {
  //   actualTop += current.offsetTop;
  //   current = current.offsetParent;
  // }
  // console.log(actualTop)
  // scrollListening();
});

onUnmounted(() => {
  // 清理交叉观察器
  if (observer) {
    observer.disconnect();
  }
  if (observerArr) {
    observerArr.disconnect();
  }
  if (t) {
    clearInterval(t);
  }

  // 清理事件监听器
  stopScrollListening();

  // 确保恢复滚动
  enableScroll();
});
</script>

<!-- 添加组件描述注释 -->
<!-- 3号模板组件：包含一个containercom，内部含有一个textcom，实现滑动监听和动画效果 -->

<template>
  <div class="template-3" ref="templateRef">
    <div ref="topRef" class="bottom"></div>
    <ContainerCom
      :contentId="props.templateId + '-container'"
      :allowFullScreenPlay="false"
      :showDelete="true"
      @delete="handleDelete"
      :showOrderNum="true"
      @order="emit('order', $event)"
      class="template-3-container"
    >
      <div class="container-content" v-if="!isMobile">
        <div v-show="isSliding" class="first-text" :style="textTransform">
          <div class="first-text-content">
            <TextCom
              v-show="isLoggedIn"
              :contentId="props.templateId + '-text-1'"
            />
            <span v-show="!isLoggedIn">{{ firstText }}</span>
          </div>
        </div>
        <div v-show="!isSliding" class="next-text">
          <div class="next-text-content-wrapper">
            <el-scrollbar
              ref="scrollbarRef"
              height="100vh"
              class="next-text-scrollbar"
              @end-reached="handleEndReached"
              @scroll="handleScrollEvent"
            >
              <div class="next-text-content-view">
                <div
                  class="next-text-content"
                  v-for="(item, index) in nextTextArr"
                  :key="index"
                >
                  {{ item }}
                </div>
                <div class="view" ref="viewRef"></div>
              </div>
            </el-scrollbar>
          </div>
        </div>
      </div>
      <div v-else class="first-container">
        <el-carousel
          height="100vh"
          direction="vertical"
          :auto-play="true"
          indicator-position="none"
        >
          <el-carousel-item
            class="el-item"
            v-for="item in nextTextArr"
            :key="item"
          >
            <div class="next-text-content">{{ item }}</div>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div></div>
    </ContainerCom>
    <div ref="bottomRef" class="bottom"></div>
  </div>
  <!-- 使用ContainerCom作为主容器 -->
</template>

<style scoped>
.container-content {
  height: 100%;
  overflow-y: v-bind(isSliding ? "hidden": "auto");
}
.template-3 {
  height: 100vh;
  width: 100vw;
  top: 0;
}
.first-text {
  /* 居中 */
  text-align: center;
  font-size: 5rem;
  background: #fff;
  /* 透明 */
  color: #000;
  font-weight: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.first-container {
  height: 100vh;
}
.el-item {
  display: flex;
  justify-content: center;
  align-items: center;
}
.next-text {
  /* 居中 */
  text-align: center;
  font-size: 5rem;
  /* 透明 */
  color: #fff;
  font-weight: 700;
  height: 100%;
  position: relative;
}

.next-text-scrollbar {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.next-text-content-wrapper {
  height: 100vh;
  /* min-height: 100%; */
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.next-text-content-view {
  height: 130px;
  width: 100%;
  position: relative;
}
.next-text-content {
  font-size: 5rem;
  /* 透明 */
  color: #fff;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  /* 支持换行 */
  flex-wrap: wrap;
  white-space: pre-wrap;
  word-break: break-word;
  text-align: center;
  line-height: 1.2;
  height: 100vh;
}
.next-text-content + .next-text-content {
  margin-top: 50px;
}
.template-3-container {
  overflow-y: auto;
}
.bottom {
  height: 1px;
  width: 100%;
}
.view {
  height: 130px;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
</style>
